import { Button } from 'components';
import { useNavigation } from 'hooks';
import { InvoiceSummary } from 'types';
import styles from './InvoicePaymentInfo.module.scss';

type Props = {
    invoice: InvoiceSummary
}

export default function InvoicePaymentInfo({ invoice }: Props) {   
    const { navigateToPayment } = useNavigation();
    const navigate = () => navigateToPayment(invoice.accountId, invoice.vendorId, invoice.paymentIdRef);

    return (
        <>          
            {invoice.paymentIdRef &&
                <>
                    <span onClick={navigate}>
                        | Payment {invoice.paymentIdRef}
                    </span>
                    <Button
                        fillMode="flat"
                        themeColor="secondary"
                        className={styles.button}
                        onClick={navigate}
                    >
                        View Payment
                    </Button>
                </>
            }              
        </>
    );
}